jQuery(document).ready(function($) {
  $('.accordion__content').each(function() {
    if ($.trim($(this).html()) == '') {
      $(this).closest('.product__accordion').hide();
    }
  });
});

$(document).ready(function() {
    $('a[href^="#"]').click(function(e) {
        e.preventDefault();

        var headerHeight = 120; // Header height
        // This time, we'll aim to position the accordion more accurately in view
        var scrollToPosition = $(this.getAttribute('href')).offset().top - headerHeight;

        $('html, body').animate({
            scrollTop: scrollToPosition
        }, 300, function() {
            // After scrolling, attempt to open the accordion if it's not already
            var target = $(e.target.getAttribute('href'));
            if(target.is('details') && !target.prop('open')) {
                target.prop('open', true);
                $('.product__accordion details').not(target).removeAttr('open');
            }
        });
    });
});
